import { isDirectChild } from '@studiometa/js-toolkit';
import { Accordion as AccordionCore } from '@studiometa/ui';

/**
 * Accordion class.
 * Optimized for nested collapses
 */
export default class Accordion extends AccordionCore {
  static config = {
    ...AccordionCore.config,
    components: {
      ...AccordionCore.config.components,
      Accordion,
    },
  };

  /**
   * On AccordionItem Open
   * @param {number} index Child index.
   * @returns {Function|boolean}
   */
  onAccordionItemOpen(index) {
    if (isDirectChild(this, 'Accordion', 'AccordionItem', this.$children.AccordionItem[index])) {
      return super.onAccordionItemOpen(index);
    }
    return false;
  }
}
